import { IconButton, Paper, Popover, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { FC, useState } from "react";
import XIcon from "@mui/icons-material/Close";

export const ShootTimeInfoPopover: FC = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  return (
    <>
      <IconButton
        size="small"
        color="inherit"
        aria-label={t("views.categoryTemplates.shootTime.info.trigger")}
        onClick={(event) => {
          event.stopPropagation(); // the compact header lives inside an accordion toggle
          setAnchorEl(event.currentTarget);
        }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(undefined)}
        // portalled content still bubbles through the React tree into the accordion toggle
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{ paper: { className: "max-w-sm rounded-md" } }}
      >
        <div className="flex flex-col gap-3 p-4">
          <div className="flex items-start justify-between gap-2">
            <Typography className="font-semibold">
              {t("views.categoryTemplates.shootTime.info.title")}
            </Typography>
            <IconButton
              size="small"
              className="-mt-1 -mr-1"
              aria-label={t("utils.actions.close")}
              onClick={() => setAnchorEl(undefined)}
            >
              <XIcon />
            </IconButton>
          </div>
          <Typography component="p" variant="body2">
            {t("views.categoryTemplates.shootTime.info.body")}
          </Typography>
          <Paper
            variant="section"
            className="flex flex-col gap-1 p-2 rounded-md"
          >
            <Typography
              variant="caption"
              color="text.secondary"
              className="uppercase tracking-wide"
            >
              {t("views.categoryTemplates.shootTime.info.underTheHood")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("views.categoryTemplates.tabs.shootTime")}{" "}
              {/* don't try to localize formula */}
              {/* eslint-disable i18next/no-literal-string */}
              <span className="font-mono">
                = F × (A × r<sup>e</sup> + b) × G
              </span>
              {/* eslint-enable i18next/no-literal-string */}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("views.categoryTemplates.shootTime.info.formulaNote")}
            </Typography>
          </Paper>
          <Typography component="p" variant="body2">
            {t("views.categoryTemplates.shootTime.info.performanceWarning")}
          </Typography>
        </div>
      </Popover>
    </>
  );
};
